// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"574":"bd7f60884df01aee4525","888":"e2c7c176816ed4ee2951","960":"de2c3ec14242a07d3d80"}[chunkId] + ".css";
};